import 'quasar/dist/quasar.css'

import { createApp } from 'vue'
import App from './App.vue'


export function bootstrap () {
  return createApp(App)
}
